import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, Typography, Grid, CircularProgress, Alert, Divider } from '@mui/material';
import backgroundImg from "../../assets/ImgFundo/fundo-abstratoC.jpg";
import { useLocation } from 'react-router-dom';

const ContagemDocumentos = () => {
    const [verbetes, setVerbetes] = useState([]);
    const [contador, setContador] = useState(0); // Estado para o contador total de visualizações
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const location = useLocation();

    useEffect(() => {
        const fetchDados = async () => {
            try {
                console.log("Iniciando as requisições para verbetes e contadores...");

                // Requisição para verbetes
                const verbetesUrl = `${apiUrl}/verbetes`;
                console.log(`Fazendo requisição para: ${verbetesUrl}`);
                const responseVerbetes = await axios.get(verbetesUrl);
                console.log("Resposta da API para verbetes:", responseVerbetes.data);
                setVerbetes(responseVerbetes.data);

                // Requisição para obter o total de visitas
                const totalVisitsUrl = `${apiUrl}/counter/BancodeDados`;
                console.log(`Fazendo requisição para: ${totalVisitsUrl}`);
                const totalResponse = await axios.get(totalVisitsUrl);
                console.log("Resposta da API para total de visitas:", totalResponse.data);

                // Verifica se a resposta contém o campo "count" e se é um número
                if (!totalResponse.data || typeof totalResponse.data.count !== 'number') {
                    throw new Error("Resposta inesperada ao obter o total de visitas.");
                }

                // Atualiza o estado com o total de visitas
                setContador(totalResponse.data.count);

                setLoading(false);
            } catch (error) {
                console.error('Erro ao carregar os dados:', error);
                setErro('Erro ao carregar os dados. Tente novamente mais tarde.');
                setLoading(false);
            }
        };

        fetchDados();
    }, [apiUrl, location.pathname]);

    if (loading) return <CircularProgress />;
    if (erro) return <Alert severity="error">{erro}</Alert>;

    return (
        <div
            style={{
                padding: '20px',
                backgroundImage: `url(${backgroundImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                color: 'white',
            }}
        >
            <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
            <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

            <Typography
                variant="h2"
                align="center"
                gutterBottom
                style={{
                    fontFamily: "'Lato', serif",
                    color: "black",
                    borderBottom: "4px solid #d4af37",
                    paddingBottom: "10px",
                    textTransform: "uppercase",
                    animation: "glow 2s infinite alternate",
                    marginTop: "7%"
                }}
            >
                Contagem de Visualizações
            </Typography>

            <Grid container spacing={3}>
                {/* Lista de Verbetes */}
                <Grid item xs={12} md={6}>
                    <Typography
                        variant="h2"
                        align="center"
                        gutterBottom
                        style={{
                            fontFamily: "'Lato', serif",
                            color: "black",
                            borderBottom: "4px solid #d4af37",
                            paddingBottom: "10px",
                            textTransform: "uppercase",
                            animation: "glow 2s infinite alternate",
                            marginTop: "7%"
                        }}
                    >
                        Verbetes
                    </Typography>
                    <Divider style={{ marginBottom: '20px', backgroundColor: '#fff' }} />
                    {verbetes.map((verbete) => (
                        <Card key={verbete._id} style={{ marginBottom: '16px', backgroundColor: 'rgba(127, 136, 108, 0.6)' }}>
                            <CardContent>
                                <Typography
                                    variant="body2"
                                    align="center"
                                    gutterBottom
                                    style={{
                                        fontFamily: "'Lato', serif",
                                        color: "black",
                                        borderBottom: "4px solid #d4af37",
                                        paddingBottom: "10px",
                                        textTransform: "uppercase",
                                        animation: "glow 2s infinite alternate",
                                        marginTop: "7%"
                                    }}
                                >
                                    {verbete.titulo}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'primary.main', fontWeight: 'bold' }}
                                >
                                    Visualizações: {verbete.visualizacoes || 0} {/* Exibe o número de visualizações */}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </Grid>

                {/* Contador de Acessos */}
                <Grid item xs={12} md={6}>
                    <Typography
                        variant="h2"
                        align="center"
                        gutterBottom
                        style={{
                            fontFamily: "'Lato', serif",
                            color: "black",
                            borderBottom: "4px solid #d4af37",
                            paddingBottom: "10px",
                            textTransform: "uppercase",
                            animation: "glow 2s infinite alternate",
                            marginTop: "7%"
                        }}
                    >
                        Contador de Buscas
                    </Typography>
                    <Divider style={{ marginBottom: '20px', backgroundColor: '#fff' }} />
                    <Card style={{ marginBottom: '16px', backgroundColor: 'rgba(159, 132, 132, 0.6)' }}>
                        <CardContent>
                            <Typography
                                variant="body2"
                                align="center"
                                gutterBottom
                                style={{
                                    fontFamily: "'Lato', serif",
                                    color: "black",
                                    borderBottom: "4px solid #d4af37",
                                    paddingBottom: "10px",
                                    textTransform: "uppercase",
                                    animation: "glow 2s infinite alternate",
                                    marginTop: "7%"
                                }}
                            >
                                Total de Buscas
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ color: 'black', fontWeight: 'bold' }}
                            >
                                Acessos: {contador} {/* Exibe o contador total de visualizações */}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default ContagemDocumentos;